import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import Main from '@/pages/Main'
import Nopay from '@/pages/Nopay'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Main',
      name: 'Main',
      component: Main
    },
    {
      path: '/Nopay',
      name: 'Nopay',
      component: Nopay
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js